module.exports = __webpack_public_path__ + "static/Gtech-fd63e0881dd0790a353557569a8ca655.png";